webpackJsonp([2,4],Array(35).concat([
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Notifications = __webpack_require__(153);

var _Notifications2 = _interopRequireDefault(_Notifications);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationStore = {
  state: [], removeNotification: function removeNotification(timestamp) {
    var indexToDelete = this.state.findIndex(function (n) {
      return n.timestamp === timestamp;
    });
    if (indexToDelete !== -1) {
      this.state.splice(indexToDelete, 1);
    }
  },
  addNotification: function addNotification(notification) {
    notification.timestamp = new Date();
    notification.timestamp.setMilliseconds(notification.timestamp.getMilliseconds() + this.state.length);
    this.state.push(notification);
  },
  notify: function notify(notification) {
    var _this = this;

    if (Array.isArray(notification)) {
      notification.forEach(function (notificationInstance) {
        _this.addNotification(notificationInstance);
      });
    } else {
      this.addNotification(notification);
    }
  }
};

var NotificationsPlugin = {
  install: function install(Vue) {
    Vue.mixin({
      data: function data() {
        return {
          notificationStore: NotificationStore
        };
      },

      methods: {
        notify: function notify(notification) {
          this.notificationStore.notify(notification);
        }
      }
    });
    Object.defineProperty(Vue.prototype, '$notify', {
      get: function get() {
        return this.$root.notify;
      }
    });
    Object.defineProperty(Vue.prototype, '$notifications', {
      get: function get() {
        return this.$root.notificationStore;
      }
    });
    Vue.component('Notifications', _Notifications2.default);
  }
};

exports.default = NotificationsPlugin;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SideBar = __webpack_require__(154);

var _SideBar2 = _interopRequireDefault(_SideBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SidebarStore = {
  showSidebar: false,
  sidebarLinks: [{
    name: 'Dashboard',
    icon: 'dashboard',
    path: '/admin/dashboard'
  }, {
    name: 'User Profile',
    icon: 'person',
    path: '/admin/stats'
  }, {
    name: 'Table List',
    icon: 'content_paste',
    path: '/admin/table-list'
  }, {
    name: 'Typography',
    icon: 'library_books',
    path: '/admin/typography'
  }, {
    name: 'Icons',
    icon: 'bubble_chart',
    path: '/admin/icons'
  }, {
    name: 'Maps',
    icon: 'location_on',
    path: '/admin/maps'
  }, {
    name: 'Notifications',
    icon: 'notifications',
    path: '/admin/notifications'
  }],
  displaySidebar: function displaySidebar(value) {
    this.showSidebar = value;
  }
};

var SidebarPlugin = {
  install: function install(Vue) {
    Vue.mixin({
      data: function data() {
        return {
          sidebarStore: SidebarStore
        };
      }
    });

    Object.defineProperty(Vue.prototype, '$sidebar', {
      get: function get() {
        return this.$root.sidebarStore;
      }
    });
    Vue.component('side-bar', _SideBar2.default);
  }
};

exports.default = SidebarPlugin;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _formGroupInput = __webpack_require__(150);

var _formGroupInput2 = _interopRequireDefault(_formGroupInput);

var _Dropdown = __webpack_require__(149);

var _Dropdown2 = _interopRequireDefault(_Dropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GlobalComponents = {
  install: function install(Vue) {
    Vue.component('fg-input', _formGroupInput2.default);
    Vue.component('drop-down', _Dropdown2.default);
  }
};

exports.default = GlobalComponents;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueClickaway = __webpack_require__(132);

var GlobalDirectives = {
  install: function install(Vue) {
    Vue.directive('click-outside', _vueClickaway.directive);
  }
};

exports.default = GlobalDirectives;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(73);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(72);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GlobalMixins = {
  install: function install(Vue) {
    Vue.mixin({
      mounted: function mounted() {
        var _this = this;

        return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
          return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 182)).then(function () {
                    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee($) {
                      return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              window.jQuery = window.$ = $;
                              _context.next = 3;
                              return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 181));

                            case 3:
                              $.material.init();

                            case 4:
                            case 'end':
                              return _context.stop();
                          }
                        }
                      }, _callee, _this);
                    }));

                    return function (_x) {
                      return _ref.apply(this, arguments);
                    };
                  }());

                case 1:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this);
        }))();
      }
    });
  }
};

exports.default = GlobalMixins;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DashboardLayout = __webpack_require__(135);

var _DashboardLayout2 = _interopRequireDefault(_DashboardLayout);

var _NotFoundPage = __webpack_require__(146);

var _NotFoundPage2 = _interopRequireDefault(_NotFoundPage);

var _Dashboard = __webpack_require__(137);

var _Dashboard2 = _interopRequireDefault(_Dashboard);

var _UserProfile = __webpack_require__(143);

var _UserProfile2 = _interopRequireDefault(_UserProfile);

var _Notifications = __webpack_require__(140);

var _Notifications2 = _interopRequireDefault(_Notifications);

var _Icons = __webpack_require__(138);

var _Icons2 = _interopRequireDefault(_Icons);

var _Maps = __webpack_require__(139);

var _Maps2 = _interopRequireDefault(_Maps);

var _Typography = __webpack_require__(142);

var _Typography2 = _interopRequireDefault(_Typography);

var _TableList = __webpack_require__(141);

var _TableList2 = _interopRequireDefault(_TableList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = [{
  path: '/',
  component: _DashboardLayout2.default,
  redirect: '/admin/dashboard'
}, {
  path: '/admin',
  component: _DashboardLayout2.default,
  redirect: '/admin/dashboard',
  children: [{
    path: 'dashboard',
    name: 'Material Dashboard',
    component: _Dashboard2.default
  }, {
    path: 'stats',
    name: 'stats',
    component: _UserProfile2.default
  }, {
    path: 'notifications',
    name: 'notifications',
    component: _Notifications2.default
  }, {
    path: 'icons',
    name: 'icons',
    component: _Icons2.default
  }, {
    path: 'maps',
    name: 'maps',
    component: _Maps2.default
  }, {
    path: 'typography',
    name: 'typography',
    component: _Typography2.default
  }, {
    path: 'table-list',
    name: 'table-list',
    component: _TableList2.default
  }]
}, { path: '*', component: _NotFoundPage2.default }];

exports.default = routes;

/***/ }),
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 44 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(47),
  /* template */
  __webpack_require__(157),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 46 */,
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TopNavbar = __webpack_require__(136);

var _TopNavbar2 = _interopRequireDefault(_TopNavbar);

var _ContentFooter = __webpack_require__(134);

var _ContentFooter2 = _interopRequireDefault(_ContentFooter);

var _Content = __webpack_require__(133);

var _Content2 = _interopRequireDefault(_Content);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    TopNavbar: _TopNavbar2.default,
    ContentFooter: _ContentFooter2.default,
    DashboardContent: _Content2.default
  },
  methods: {
    toggleSidebar: function toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  computed: {
    routeName: function routeName() {
      var name = this.$route.name;

      return this.capitalizeFirstLetter(name);
    }
  },
  data: function data() {
    return {
      activeNotifications: false
    };
  },

  methods: {
    capitalizeFirstLetter: function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown: function toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown: function closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar: function toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar: function hideSidebar() {
      this.$sidebar.displaySidebar(false);
    }
  }
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StatsCard = __webpack_require__(148);

var _StatsCard2 = _interopRequireDefault(_StatsCard);

var _ChartCard = __webpack_require__(147);

var _ChartCard2 = _interopRequireDefault(_ChartCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    StatsCard: _StatsCard2.default,
    ChartCard: _ChartCard2.default
  },
  data: function data() {
    return {
      dailySalesChart: {
        data: {
          labels: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],
          series: [[12, 17, 7, 17, 23, 18, 38]]
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 0
          }),
          low: 0,
          high: 50,
          chartPadding: { top: 0, right: 0, bottom: 0, left: 0 }
        }
      },
      completedTasksChart: {
        data: {
          labels: ['12am', '3pm', '6pm', '9pm', '12pm', '3am', '6am', '9am'],
          series: [[230, 750, 450, 300, 280, 240, 200, 190]]
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 0
          }),
          low: 0,
          high: 1000,
          chartPadding: { top: 0, right: 0, bottom: 0, left: 0 }
        }
      },
      emailSubscriptionsChart: {
        data: {
          labels: ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          series: [[542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895]]
        },
        options: {
          axisX: {
            showGrid: false
          },
          low: 0,
          high: 1000,
          chartPadding: { top: 0, right: 5, bottom: 0, left: 0 }
        },
        responsiveOptions: [['screen and (max-width: 640px)', {
          seriesBarDistance: 5,
          axisX: {
            labelInterpolationFnc: function labelInterpolationFnc(value) {
              return value[0];
            }
          }
        }]]
      }

    };
  }
};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _googleMaps = __webpack_require__(129);

var _googleMaps2 = _interopRequireDefault(_googleMaps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  methods: {
    initMap: function initMap(google) {
      var myLatlng = new google.maps.LatLng(40.748817, -73.985428);
      var mapOptions = {
        zoom: 13,
        center: myLatlng,
        scrollwheel: false,
        styles: [{
          'featureType': 'water',
          'stylers': [{ 'saturation': 43 }, { 'lightness': -11 }, { 'hue': '#0088ff' }]
        }, {
          'featureType': 'road',
          'elementType': 'geometry.fill',
          'stylers': [{ 'hue': '#ff0000' }, { 'saturation': -100 }, { 'lightness': 99 }]
        }, {
          'featureType': 'road',
          'elementType': 'geometry.stroke',
          'stylers': [{ 'color': '#808080' }, { 'lightness': 54 }]
        }, {
          'featureType': 'landscape.man_made',
          'elementType': 'geometry.fill',
          'stylers': [{ 'color': '#ece2d9' }]
        }, {
          'featureType': 'poi.park',
          'elementType': 'geometry.fill',
          'stylers': [{ 'color': '#ccdca1' }]
        }, {
          'featureType': 'road',
          'elementType': 'labels.text.fill',
          'stylers': [{ 'color': '#767676' }]
        }, {
          'featureType': 'road',
          'elementType': 'labels.text.stroke',
          'stylers': [{ 'color': '#ffffff' }]
        }, { 'featureType': 'poi', 'stylers': [{ 'visibility': 'off' }] }, {
          'featureType': 'landscape.natural',
          'elementType': 'geometry.fill',
          'stylers': [{ 'visibility': 'on' }, { 'color': '#b8cb93' }]
        }, { 'featureType': 'poi.park', 'stylers': [{ 'visibility': 'on' }] }, {
          'featureType': 'poi.sports_complex',
          'stylers': [{ 'visibility': 'on' }]
        }, { 'featureType': 'poi.medical', 'stylers': [{ 'visibility': 'on' }] }, {
          'featureType': 'poi.business',
          'stylers': [{ 'visibility': 'simplified' }]
        }]

      };
      var map = new google.maps.Map(document.getElementById('map'), mapOptions);

      var marker = new google.maps.Marker({
        position: myLatlng,
        title: 'Hello World!'
      });

      marker.setMap(map);
    }
  },
  mounted: function mounted() {
    var _this = this;

    _googleMaps2.default.KEY = 'AIzaSyAamVCoyQ4AuvBpxVRMs9P-HFkfPVQj0Kw';
    _googleMaps2.default.load(function (google) {
      _this.initMap(google);
    });
  }
};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      type: ['', 'info', 'success', 'warning', 'danger'],
      notifications: {
        topCenter: false
      }
    };
  },

  methods: {
    notifyVue: function notifyVue(verticalAlign, horizontalAlign) {
      var color = Math.floor(Math.random() * 4 + 1);
      this.$notify({
        message: 'Welcome to <b>Material Dashboard</b> - a beautiful freebie for every web developer.',
        icon: 'notifications',
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: this.type[color]
      });
    }
  }
};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MaterialTable = __webpack_require__(151);

var _MaterialTable2 = _interopRequireDefault(_MaterialTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tableColumns = ['Id', 'Name', 'Salary', 'Country', 'City'];
var tableData = [{
  id: 1,
  name: 'Dakota Rice',
  salary: '$36.738',
  country: 'Niger',
  city: 'Oud-Turnhout'
}, {
  id: 2,
  name: 'Minerva Hooper',
  salary: '$23,789',
  country: 'Curaçao',
  city: 'Sinaai-Waas'
}, {
  id: 3,
  name: 'Sage Rodriguez',
  salary: '$56,142',
  country: 'Netherlands',
  city: 'Baileux'
}, {
  id: 4,
  name: 'Philip Chaney',
  salary: '$38,735',
  country: 'Korea, South',
  city: 'Overland Park'
}, {
  id: 5,
  name: 'Doris Greene',
  salary: '$63,542',
  country: 'Malawi',
  city: 'Feldkirchen in Kärnten'
}];

exports.default = {
  components: {
    MaterialTable: _MaterialTable2.default
  },
  data: function data() {
    return {
      table1: {
        title: 'Stripped Table',
        subTitle: 'Here is a subtitle for this table',
        columns: [].concat(tableColumns),
        data: [].concat(tableData)
      },
      table2: {
        title: 'Table on Plain Background',
        subTitle: 'Here is a subtitle for this table',
        columns: [].concat(tableColumns),
        data: [].concat(tableData)
      }
    };
  }
};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EditProfileForm = __webpack_require__(144);

var _EditProfileForm2 = _interopRequireDefault(_EditProfileForm);

var _UserCard = __webpack_require__(145);

var _UserCard2 = _interopRequireDefault(_UserCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    EditProfileForm: _EditProfileForm2.default,
    UserCard: _UserCard2.default
  }
};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(70);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      user: {
        company: 'Material Dashboard',
        username: 'michael23',
        email: '',
        lastName: 'Faker',
        address: 'Melbourne, Australia',
        city: 'melbourne',
        postalCode: '',
        aboutMe: 'Oh so, your weak rhyme. You doubt I\'ll bother, reading into it.I\'ll probably won\'t, left to my own devicesBut that\'s the difference in our opinions.'
      }
    };
  },

  methods: {
    updateProfile: function updateProfile() {
      alert('Your data: ' + (0, _stringify2.default)(this.user));
    }
  }
};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'chart-card',
  props: {
    footerText: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'green'
    },
    id: String,
    headerTitle: {
      type: String,
      default: 'Chart title'
    },
    chartType: {
      type: String,
      default: 'Line' },
    chartOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    responsiveOptions: [Object, Array],
    chartData: {
      type: Object,
      default: function _default() {
        return {
          labels: [],
          series: []
        };
      }
    }
  },
  data: function data() {
    return {
      chartId: 'no-id',
      chart: {}
    };
  },

  methods: {
    initChart: function initChart() {
      var chartIdQuery = '#' + this.chartId;
      this.chart = this.$Chartist[this.chartType](chartIdQuery, this.chartData, this.chartOptions, this.responsiveOptions);
      if (this.chartType === 'Line') {
        this.animateLineChart();
      }
      if (this.chartType === 'Bar') {
        this.animateBarChart();
      }
    },
    updateChartId: function updateChartId() {
      var currentTime = new Date().getTime().toString();
      var randomInt = this.getRandomInt(0, currentTime);
      this.chartId = 'div_' + randomInt;
    },
    getRandomInt: function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    animateLineChart: function animateLineChart() {
      var _this = this;

      var seq = 0;
      var durations = 500;
      var delays = 80;
      this.chart.on('draw', function (data) {
        if (data.type === 'line' || data.type === 'area') {
          data.element.animate({
            d: {
              begin: 600,
              dur: 700,
              from: data.path.clone().scale(1, 0).translate(0, data.chartRect.height()).stringify(),
              to: data.path.clone().stringify(),
              easing: _this.$Chartist.Svg.Easing.easeOutQuint
            }
          });
        } else if (data.type === 'point') {
          seq++;
          data.element.animate({
            opacity: {
              begin: seq * delays,
              dur: durations,
              from: 0,
              to: 1,
              easing: 'ease'
            }
          });
        }
      });
      seq = 0;
    },
    animateBarChart: function animateBarChart() {
      var seq = 0;
      var durations = 500;
      var delays = 80;
      this.chart.on('draw', function (data) {
        if (data.type === 'bar') {
          seq++;
          data.element.animate({
            opacity: {
              begin: seq * delays,
              dur: durations,
              from: 0,
              to: 1,
              easing: 'ease'
            }
          });
        }
      });
    }
  },
  mounted: function mounted() {
    if (!this.id) {
      this.updateChartId();
    } else {
      this.chartId = this.id;
    }
    this.$nextTick(this.initChart);
  }
};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'stats-card',
  props: {
    color: {
      type: String,
      default: 'orange'
    }
  }
};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    title: String,
    icon: String
  },
  data: function data() {
    return {
      isOpen: false
    };
  },

  methods: {
    toggleDropDown: function toggleDropDown() {
      this.isOpen = !this.isOpen;
    },
    closeDropDown: function closeDropDown() {
      this.isOpen = false;
    }
  }
};

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    type: {
      type: String,
      default: 'text'
    },
    label: String,
    name: String,
    disabled: Boolean,
    placeholder: String,
    value: [String, Number]
  }
};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    columns: Array,
    data: Array,
    type: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''

    }
  },
  computed: {
    tableClass: function tableClass() {
      return 'table-' + this.type;
    },
    isPlain: function isPlain() {
      return this.type === 'plain';
    }
  },
  methods: {
    hasValue: function hasValue(item, column) {
      return item[column.toLowerCase()] !== 'undefined';
    },
    itemValue: function itemValue(item, column) {
      return item[column.toLowerCase()];
    }
  }
};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'notification',
  props: {
    message: String,
    icon: String,
    verticalAlign: {
      type: String,
      default: 'top'
    },
    horizontalAlign: {
      type: String,
      default: 'center'
    },
    type: {
      type: String,
      default: 'info'
    },
    timeout: {
      type: Number,
      default: 5000
    },
    timestamp: {
      type: Date,
      default: function _default() {
        return new Date();
      }
    }
  },
  data: function data() {
    return {
      elmHeight: 0
    };
  },

  computed: {
    hasIcon: function hasIcon() {
      return this.icon && this.icon.length > 0;
    },
    alertType: function alertType() {
      return 'alert-' + this.type;
    },
    customPosition: function customPosition() {
      var _this = this;

      var initialMargin = 20;
      var alertHeight = this.elmHeight + 10;
      var sameAlertsCount = this.$notifications.state.filter(function (alert) {
        return alert.horizontalAlign === _this.horizontalAlign && alert.verticalAlign === _this.verticalAlign && alert.timestamp <= _this.timestamp;
      }).length;
      var pixels = (sameAlertsCount - 1) * alertHeight + initialMargin;
      var styles = {};
      if (this.verticalAlign === 'top') {
        styles.top = pixels + 'px';
      } else {
        styles.bottom = pixels + 'px';
      }
      return styles;
    }
  },
  methods: {
    close: function close() {
      this.$emit('on-close', this.timestamp);
    }
  },
  mounted: function mounted() {
    this.elmHeight = this.$el.clientHeight;
    if (this.timeout) {
      setTimeout(this.close, this.timeout);
    }
  }
};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Notification = __webpack_require__(152);

var _Notification2 = _interopRequireDefault(_Notification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Notification: _Notification2.default
  },
  data: function data() {
    return {
      notifications: this.$notifications.state
    };
  },

  methods: {
    removeNotification: function removeNotification(timestamp) {
      this.$notifications.removeNotification(timestamp);
    }
  }
};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    type: {
      type: String,
      default: 'sidebar',
      validator: function validator(value) {
        var acceptedValues = ['sidebar', 'navbar'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    backgroundColor: {
      type: String,
      default: 'purple',
      validator: function validator(value) {
        var acceptedValues = ['purple', 'black', 'darkblue'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    activeColor: {
      type: String,
      default: 'success',
      validator: function validator(value) {
        var acceptedValues = ['primary', 'info', 'success', 'warning', 'danger'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    sidebarLinks: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    sidebarClasses: function sidebarClasses() {
      if (this.type === 'sidebar') {
        return 'sidebar';
      } else {
        return 'collapse navbar-collapse off-canvas-sidebar';
      }
    },
    navClasses: function navClasses() {
      if (this.type === 'sidebar') {
        return 'nav';
      } else {
        return 'nav navbar-nav';
      }
    },
    arrowMovePx: function arrowMovePx() {
      return this.linkHeight * this.activeLinkIndex;
    }
  },
  data: function data() {
    return {
      linkHeight: 60,
      activeLinkIndex: 0,

      windowWidth: 0,
      isWindows: false,
      hasAutoHeight: false
    };
  },

  methods: {
    findActiveLink: function findActiveLink() {
      var _this = this;

      this.sidebarLinks.find(function (element, index) {
        var found = element.path === _this.$route.path;
        if (found) {
          _this.activeLinkIndex = index;
        }
        return found;
      });
    }
  },
  mounted: function mounted() {
    this.findActiveLink();
  },

  watch: {
    $route: function $route(newRoute, oldRoute) {
      this.findActiveLink();
    }
  }
};

/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 110 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 111 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 113 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 114 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 116 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 118 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 119 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 120 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 122 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 123 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 124 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 126 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 127 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 128 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(110)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(156),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(122)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(171),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(120)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(169),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(114)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(51),
  /* template */
  __webpack_require__(161),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(119)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(52),
  /* template */
  __webpack_require__(166),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(109)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(155),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(116)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(54),
  /* template */
  __webpack_require__(163),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(115)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(55),
  /* template */
  __webpack_require__(162),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(121)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(170),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(124)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(57),
  /* template */
  __webpack_require__(173),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(123)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(58),
  /* template */
  __webpack_require__(172),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(127)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(176),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(125)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(60),
  /* template */
  __webpack_require__(174),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(61),
  /* template */
  __webpack_require__(167),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(118)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(165),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(117)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(63),
  /* template */
  __webpack_require__(164),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(64),
  /* template */
  __webpack_require__(168),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(112)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(159),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(126)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(66),
  /* template */
  __webpack_require__(175),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(113)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(67),
  /* template */
  __webpack_require__(160),
  /* scopeId */
  "data-v-4679d3d9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(128)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(177),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(111)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(69),
  /* template */
  __webpack_require__(158),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-plain"
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "data-background-color": "purple"
    }
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Material Design Icons")]), _vm._v(" "), _c('p', {
    staticClass: "category"
  }, [_vm._v("Handcrafted by our friends from "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://design.google.com/icons/"
    }
  }, [_vm._v("Google")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "iframe-container hidden-sm hidden-xs"
  }, [_c('iframe', {
    attrs: {
      "src": "https://design.google.com/icons/"
    }
  }, [_c('p', [_vm._v("Your browser does not support iframes.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 hidden-lg hidden-md text-center"
  }, [_c('h5', [_vm._v("\n                The icons are visible on Desktop mode inside an iframe. Since the iframe is not working on Mobile and Tablets please visit the icons on their original page on Google. Check the  "), _c('a', {
    attrs: {
      "href": "https://design.google.com/icons/",
      "target": "_blank"
    }
  }, [_vm._v("Material Icons")])])])])])])])])])
}]}

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'nav-open': _vm.$sidebar.showSidebar
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.sidebarClasses,
    staticStyle: {
      "background-image": "url(static/img/sidebar-1.jpg)"
    },
    attrs: {
      "data-color": _vm.backgroundColor,
      "data-image": "static/img/sidebar-1.jpg",
      "data-active-color": _vm.activeColor
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sidebar-wrapper"
  }, [_vm._t("default"), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-mobile-menu"
  }, [_vm._m(1), _vm._v(" "), _c('drop-down', [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown"
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("notifications")]), _vm._v(" "), _c('span', {
    staticClass: "notification"
  }, [_vm._v("5")]), _vm._v(" "), _c('p', {
    staticClass: "hidden-lg hidden-md"
  }, [_vm._v("Notifications")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Mike John responded to your email")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("You have 5 new tasks")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("You're now friend with Andrew")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Another Notification")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Another One")])])]), _vm._v(" "), _vm._m(2)], 1), _vm._v(" "), _c('ul', {
    class: _vm.navClasses
  }, _vm._l((_vm.sidebarLinks), function(link, index) {
    return _c('router-link', {
      ref: link.name,
      refInFor: true,
      attrs: {
        "to": link.path,
        "tag": "li"
      }
    }, [_c('a', [(link.icon) ? _c('i', {
      staticClass: "material-icons"
    }, [_vm._v(_vm._s(link.icon))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(link.name) + "\n          ")])])])
  }))], 2), _vm._v(" "), _c('div', {
    staticClass: "sidebar-background",
    staticStyle: {
      "background-image": "url(static/img/sidebar-1.jpg)"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('a', {
    staticClass: "simple-text",
    attrs: {
      "href": "http://www.creative-tim.com"
    }
  }, [_vm._v("\n      Creative Tim\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "dropdown-toggle active",
    attrs: {
      "href": "#/",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("dashboard")]), _vm._v(" "), _c('p', {
    staticClass: "hidden-lg hidden-md"
  }, [_vm._v("Dashboard")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("person")]), _vm._v(" "), _c('p', {
    staticClass: "hidden-lg hidden-md"
  }, [_vm._v("Profile")])])])
}]}

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group label-floating"
  }, [(_vm.label) ? _c('label', {
    staticClass: "control-label"
  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('input', _vm._b({
    staticClass: "form-control border-input",
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event.target.value)
      }
    }
  }, 'input', _vm.$props, false))])
},staticRenderFns: []}

/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-11 col-sm-4 alert open alert-with-icon",
    class: [_vm.verticalAlign, _vm.horizontalAlign, _vm.alertType],
    style: (_vm.customPosition),
    attrs: {
      "data-notify": "container",
      "role": "alert",
      "data-notify-position": "top-center"
    },
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true",
      "data-notify": "dismiss"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("×\n  ")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons",
    attrs: {
      "data-notify": "icon"
    }
  }, [_vm._v(_vm._s(_vm.icon))]), _vm._v(" "), _c('span', {
    attrs: {
      "data-notify": "message"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-transparent navbar-absolute"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "collapse"
    },
    on: {
      "click": _vm.toggleSidebar
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.capitalizeFirstLetter(_vm.$route.name)))])]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse"
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_vm._m(0), _vm._v(" "), _c('drop-down', [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown"
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("notifications")]), _vm._v(" "), _c('span', {
    staticClass: "notification"
  }, [_vm._v("5")]), _vm._v(" "), _c('p', {
    staticClass: "hidden-lg hidden-md"
  }, [_vm._v("Notifications")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Mike John responded to your email")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("You have 5 new tasks")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("You're now friend with Andrew")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Another Notification")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Another One")])])]), _vm._v(" "), _vm._m(1)], 1), _vm._v(" "), _vm._m(2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:void(0)",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("dashboard")]), _vm._v(" "), _c('p', {
    staticClass: "hidden-lg hidden-md"
  }, [_vm._v("Dashboard")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:void(0)",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("person")]), _vm._v(" "), _c('p', {
    staticClass: "hidden-lg hidden-md"
  }, [_vm._v("Profile")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "navbar-form navbar-right",
    attrs: {
      "role": "search"
    }
  }, [_c('div', {
    staticClass: "form-group  is-empty"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "material-input"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-white btn-round btn-just-icon",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("search")]), _c('div', {
    staticClass: "ripple-container"
  })])])
}]}

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_vm._m(1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "places-buttons"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        _vm.notifyVue('top', 'left')
      }
    }
  }, [_vm._v("Top Left")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        _vm.notifyVue('top', 'center')
      }
    }
  }, [_vm._v("Top Center")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        _vm.notifyVue('top', 'right')
      }
    }
  }, [_vm._v("Top Right")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        _vm.notifyVue('bottom', 'left')
      }
    }
  }, [_vm._v("Bottom Left")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        _vm.notifyVue('bottom', 'center')
      }
    }
  }, [_vm._v("Bottom Center")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        _vm.notifyVue('bottom', 'right')
      }
    }
  }, [_vm._v("Bottom Right")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header",
    attrs: {
      "data-background-color": "purple"
    }
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Notifications")]), _vm._v(" "), _c('p', {
    staticClass: "category"
  }, [_vm._v("Handcrafted by us with "), _c('i', {
    staticClass: "fa fa-heart heart"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h5', [_vm._v("Notifications Style")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-info"
  }, [_c('span', [_vm._v("This is a plain notification")])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-info"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', [_vm._v("This is a notification with close button.")])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-info alert-with-icon",
    attrs: {
      "data-notify": "container"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons",
    attrs: {
      "data-notify": "icon"
    }
  }, [_vm._v("add_alert")]), _vm._v(" "), _c('span', {
    attrs: {
      "data-notify": "message"
    }
  }, [_vm._v("This is a notification with close button and icon.")])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-info alert-with-icon",
    attrs: {
      "data-notify": "container"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons",
    attrs: {
      "data-notify": "icon"
    }
  }, [_vm._v("add_alert")]), _vm._v(" "), _c('span', {
    attrs: {
      "data-notify": "message"
    }
  }, [_vm._v("This is a notification with close button and icon and have many lines. You can see that the icon and the close button are always vertically aligned. This is a beautiful notification. So you don't have to worry about the style.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h5', [_vm._v("Notification states")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-info"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', [_c('b', [_vm._v(" Info - ")]), _vm._v(" This is a regular notification made with \".alert-info\"")])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-success"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', [_c('b', [_vm._v(" Success - ")]), _vm._v(" This is a regular notification made with \".alert-success\"")])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', [_c('b', [_vm._v(" Warning - ")]), _vm._v(" This is a regular notification made with \".alert-warning\"")])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', [_c('b', [_vm._v(" Danger - ")]), _vm._v(" This is a regular notification made with \".alert-danger\"")])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-primary"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', [_c('b', [_vm._v(" Primary - ")]), _vm._v(" This is a regular notification made with \".alert-primary\"")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3 text-center"
  }, [_c('h5', [_vm._v("Notifications Places\n                "), _c('p', {
    staticClass: "category"
  }, [_vm._v("Click to view notifications")])])])])
}]}

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "map"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-stats"
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "data-background-color": _vm.color
    }
  }, [_vm._t("icon")], 2), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_vm._t("title")], 2), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "stats"
  }, [_vm._t("footer")], 2)])])
},staticRenderFns: []}

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header card-chart",
    attrs: {
      "data-background-color": _vm.color
    }
  }, [_c('div', {
    staticClass: "ct-chart",
    attrs: {
      "id": _vm.chartId
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_vm._t("title")], 2), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "stats"
  }, [_vm._t("footer")], 2)])])
},staticRenderFns: []}

/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-6 col-sm-6"
  }, [_c('stats-card', [_c('i', {
    staticClass: "material-icons",
    slot: "icon"
  }, [_vm._v("content_copy")]), _vm._v(" "), _c('div', {
    slot: "title"
  }, [_c('p', {
    staticClass: "category"
  }, [_vm._v("Used Space")]), _vm._v(" "), _c('h3', {
    staticClass: "title"
  }, [_vm._v("49/50\n                  "), _c('small', [_vm._v("GB")])])]), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('i', {
    staticClass: "material-icons text-danger"
  }, [_vm._v("warning")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#pablo"
    }
  }, [_vm._v("Get More Space...")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-6 col-sm-6"
  }, [_c('stats-card', {
    attrs: {
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "material-icons",
    slot: "icon"
  }, [_vm._v("store")]), _vm._v(" "), _c('div', {
    slot: "title"
  }, [_c('p', {
    staticClass: "category"
  }, [_vm._v("Revenue")]), _vm._v(" "), _c('h3', {
    staticClass: "title"
  }, [_vm._v("$34,245")])]), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("date_range")]), _vm._v(" Last 24 Hours\n              ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-6 col-sm-6"
  }, [_c('stats-card', {
    attrs: {
      "color": "red"
    }
  }, [_c('i', {
    staticClass: "material-icons",
    slot: "icon"
  }, [_vm._v("info_outline")]), _vm._v(" "), _c('div', {
    slot: "title"
  }, [_c('p', {
    staticClass: "category"
  }, [_vm._v("Fixed Issues")]), _vm._v(" "), _c('h3', {
    staticClass: "title"
  }, [_vm._v("75")])]), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("local_offer")]), _vm._v(" Tracked from Github\n              ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-6 col-sm-6"
  }, [_c('stats-card', {
    attrs: {
      "color": "blue"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter",
    slot: "icon"
  }), _vm._v(" "), _c('div', {
    slot: "title"
  }, [_c('p', {
    staticClass: "category"
  }, [_vm._v("Followers")]), _vm._v(" "), _c('h3', {
    staticClass: "title"
  }, [_vm._v("+245")])]), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("update")]), _vm._v(" Just Updated\n              ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('chart-card', {
    attrs: {
      "id": "dailySales",
      "chart-data": _vm.dailySalesChart.data,
      "chart-options": _vm.dailySalesChart.options
    }
  }, [_c('div', {
    slot: "title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Daily Sales")]), _vm._v(" "), _c('p', {
    staticClass: "category"
  }, [_c('span', {
    staticClass: "text-success"
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-up"
  }), _vm._v(" 55%  ")]), _vm._v("\n                  increase in today sales.")])]), _vm._v(" "), _c('span', {
    slot: "footer"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("access_time")]), _vm._v(" updated 4 minutes ago\n          ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('chart-card', {
    attrs: {
      "color": "orange",
      "chart-type": "Bar",
      "id": "emailSubscriptions",
      "chart-data": _vm.emailSubscriptionsChart.data,
      "chart-options": _vm.emailSubscriptionsChart.options,
      "responsive-options": _vm.emailSubscriptionsChart.responsiveOptions
    }
  }, [_c('div', {
    slot: "title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Email Subscriptions")]), _vm._v(" "), _c('p', {
    staticClass: "category"
  }, [_vm._v("Last Campaign Performance")])]), _vm._v(" "), _c('span', {
    slot: "footer"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("access_time")]), _vm._v(" campaign sent 2 days ago\n          ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('chart-card', {
    attrs: {
      "color": "red",
      "id": "completedTasks",
      "chart-data": _vm.completedTasksChart.data,
      "chart-options": _vm.completedTasksChart.options
    }
  }, [_c('div', {
    slot: "title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Completed Tasks")]), _vm._v(" "), _c('p', {
    staticClass: "category"
  }, [_vm._v("Last Campaign Performance")])]), _vm._v(" "), _c('span', {
    slot: "footer"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("access_time")]), _vm._v(" campaign sent 2 days ago\n          ")])])], 1)]), _vm._v(" "), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-12"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "data-background-color": "orange"
    }
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Employees Stats")]), _vm._v(" "), _c('p', {
    staticClass: "category"
  }, [_vm._v("New employees on 15th September, 2016")])]), _vm._v(" "), _c('div', {
    staticClass: "card-content table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', {
    staticClass: "text-warning"
  }, [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Salary")]), _vm._v(" "), _c('th', [_vm._v("Country")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("Dakota Rice")]), _vm._v(" "), _c('td', [_vm._v("$36,738")]), _vm._v(" "), _c('td', [_vm._v("Niger")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("Minerva Hooper")]), _vm._v(" "), _c('td', [_vm._v("$23,789")]), _vm._v(" "), _c('td', [_vm._v("Curaçao")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_vm._v("Sage Rodriguez")]), _vm._v(" "), _c('td', [_vm._v("$56,142")]), _vm._v(" "), _c('td', [_vm._v("Netherlands")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4")]), _vm._v(" "), _c('td', [_vm._v("Philip Chaney")]), _vm._v(" "), _c('td', [_vm._v("$38,735")]), _vm._v(" "), _c('td', [_vm._v("Korea, South")])])])])])])])])
}]}

/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-us full-screen"
  }, [_c('nav', {
    staticClass: "navbar navbar-ct-default",
    attrs: {
      "role": "navigation-demo"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": {
        path: '/admin'
      }
    }
  }, [_vm._v("Dashboard")])], 1)])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('footer', {
    staticClass: "footer-demo"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('nav', {
    staticClass: "pull-left"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/register'
      }
    }
  }, [_vm._v("Register")])], 1)])]), _vm._v(" "), _vm._m(2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navigation-example-2"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper wrapper-full-page section content"
  }, [_c('div', {}, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2 text-center"
  }, [_c('h2', {
    staticClass: "title text-danger"
  }, [_vm._v("404 Not Found")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("Oops! It seems that this page does not exist.")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copyright pull-right"
  }, [_vm._v("\n        © 2017, made with\n        "), _c('i', {
    staticClass: "fa fa-heart heart"
  }), _vm._v(" by Material admin\n      ")])
}]}

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.closeDropDown),
      expression: "closeDropDown"
    }],
    staticClass: "dropdown",
    class: {
      open: _vm.isOpen
    },
    on: {
      "click": _vm.toggleDropDown
    }
  }, [_c('a', {
    staticClass: "dropdown-toggle btn-rotate",
    attrs: {
      "data-toggle": "dropdown",
      "href": "javascript:void(0)"
    }
  }, [_vm._t("title", [_c('i', {
    class: _vm.icon
  }), _vm._v(" "), _c('p', {
    staticClass: "notification"
  }, [_vm._v(_vm._s(_vm.title) + "\n        "), _c('b', {
    staticClass: "caret"
  })])])], 2), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('side-bar', {
    attrs: {
      "type": "sidebar",
      "sidebar-links": _vm.$sidebar.sidebarLinks
    }
  }), _vm._v(" "), _c('notifications'), _vm._v(" "), _c('div', {
    staticClass: "main-panel"
  }, [_c('top-navbar'), _vm._v(" "), _c('dashboard-content', {
    nativeOn: {
      "click": function($event) {
        _vm.toggleSidebar($event)
      }
    }
  }), _vm._v(" "), _c('content-footer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 170 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('material-table', {
    attrs: {
      "title": _vm.table1.title,
      "sub-title": _vm.table1.subTitle,
      "data": _vm.table1.data,
      "columns": _vm.table1.columns
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('material-table', {
    attrs: {
      "type": "plain",
      "title": _vm.table2.title,
      "sub-title": _vm.table2.subTitle,
      "data": _vm.table2.data,
      "columns": _vm.table2.columns
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('nav', {
    staticClass: "pull-left"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/admin'
      }
    }
  }, [_vm._v("Dashboard")])], 1)])]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copyright pull-right"
  }, [_vm._v("\n      © Coded with\n      "), _c('i', {
    staticClass: "fa fa-heart heart"
  }), _vm._v(" by\n      "), _c('a', {
    attrs: {
      "href": "https://github.com/cristijora",
      "target": "_blank"
    }
  }, [_vm._v("Cristi Jora")]), _vm._v(".\n      Designed by "), _c('a', {
    attrs: {
      "href": "https://www.creative-tim.com/?ref=pdf-vuejs",
      "target": "_blank"
    }
  }, [_vm._v("Creative Tim")]), _vm._v(".\n    ")])
}]}

/***/ }),
/* 172 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('edit-profile-form')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('user-card')], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 173 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "data-background-color": "purple"
    }
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Material Dashboard Heading")]), _vm._v(" "), _c('p', {
    staticClass: "category"
  }, [_vm._v("Created using Roboto Font Family")])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    attrs: {
      "id": "typography"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("Typography")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "tim-typo"
  }, [_c('h1', [_c('span', {
    staticClass: "tim-note"
  }, [_vm._v("Header 1")]), _vm._v("The Life of Material Dashboard ")])]), _vm._v(" "), _c('div', {
    staticClass: "tim-typo"
  }, [_c('h2', [_c('span', {
    staticClass: "tim-note"
  }, [_vm._v("Header 2")]), _vm._v("The life of Material Dashboard ")])]), _vm._v(" "), _c('div', {
    staticClass: "tim-typo"
  }, [_c('h3', [_c('span', {
    staticClass: "tim-note"
  }, [_vm._v("Header 3")]), _vm._v("The life of Material Dashboard ")])]), _vm._v(" "), _c('div', {
    staticClass: "tim-typo"
  }, [_c('h4', [_c('span', {
    staticClass: "tim-note"
  }, [_vm._v("Header 4")]), _vm._v("The life of Material Dashboard ")])]), _vm._v(" "), _c('div', {
    staticClass: "tim-typo"
  }, [_c('h5', [_c('span', {
    staticClass: "tim-note"
  }, [_vm._v("Header 5")]), _vm._v("The life of Material Dashboard ")])]), _vm._v(" "), _c('div', {
    staticClass: "tim-typo"
  }, [_c('h6', [_c('span', {
    staticClass: "tim-note"
  }, [_vm._v("Header 6")]), _vm._v("The life of Material Dashboard ")])]), _vm._v(" "), _c('div', {
    staticClass: "tim-typo"
  }, [_c('p', [_c('span', {
    staticClass: "tim-note"
  }, [_vm._v("Paragraph")]), _vm._v("\n                    I will be the leader of a company that ends up being worth billions of dollars, because I got the answers. I understand culture. I am the nucleus. I think that’s a responsibility that I have, to push possibilities, to show people, this is the level that things could be at.")])]), _vm._v(" "), _c('div', {
    staticClass: "tim-typo"
  }, [_c('span', {
    staticClass: "tim-note"
  }, [_vm._v("Quote")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("\n                      I will be the leader of a company that ends up being worth billions of dollars, because I got the answers. I understand culture. I am the nucleus. I think that’s a responsibility that I have, to push possibilities, to show people, this is the level that things could be at.\n                    ")]), _vm._v(" "), _c('small', [_vm._v("\n                      Kanye West, Musician\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "tim-typo"
  }, [_c('span', {
    staticClass: "tim-note"
  }, [_vm._v("Muted Text")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n                    I will be the leader of a company that ends up being worth billions of dollars, because I got the answers...\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "tim-typo"
  }, [_c('span', {
    staticClass: "tim-note"
  }, [_vm._v("Primary Text")]), _vm._v(" "), _c('p', {
    staticClass: "text-primary"
  }, [_vm._v("\n                    I will be the leader of a company that ends up being worth billions of dollars, because I got the answers...                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "tim-typo"
  }, [_c('span', {
    staticClass: "tim-note"
  }, [_vm._v("Info Text")]), _vm._v(" "), _c('p', {
    staticClass: "text-info"
  }, [_vm._v("\n                    I will be the leader of a company that ends up being worth billions of dollars, because I got the answers...                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "tim-typo"
  }, [_c('span', {
    staticClass: "tim-note"
  }, [_vm._v("Success Text")]), _vm._v(" "), _c('p', {
    staticClass: "text-success"
  }, [_vm._v("\n                    I will be the leader of a company that ends up being worth billions of dollars, because I got the answers...                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "tim-typo"
  }, [_c('span', {
    staticClass: "tim-note"
  }, [_vm._v("Warning Text")]), _vm._v(" "), _c('p', {
    staticClass: "text-warning"
  }, [_vm._v("\n                    I will be the leader of a company that ends up being worth billions of dollars, because I got the answers...\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "tim-typo"
  }, [_c('span', {
    staticClass: "tim-note"
  }, [_vm._v("Danger Text")]), _vm._v(" "), _c('p', {
    staticClass: "text-danger"
  }, [_vm._v("\n                    I will be the leader of a company that ends up being worth billions of dollars, because I got the answers...                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "tim-typo"
  }, [_c('h2', [_c('span', {
    staticClass: "tim-note"
  }, [_vm._v("Small Tag")]), _vm._v("\n                    Header with small subtitle "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Use \"small\" tag for the headers")])])])])])])])])])])])
}]}

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-profile"
  }, [_c('div', {
    staticClass: "card-avatar"
  }, [_c('a', {
    attrs: {
      "href": "#pablo"
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": "static/img/faces/marc.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h6', {
    staticClass: "category text-gray"
  }, [_vm._v("CEO / Co-Founder")]), _vm._v(" "), _c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Alec Thompson")]), _vm._v(" "), _c('p', {
    staticClass: "card-content"
  }, [_vm._v("\n    Don't be scared of the truth because we need to restart the human foundation in truth And I love you like Kanye loves Kanye I love Rick Owens’ bed design but the back is...\n  ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-round",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("Follow")])])])
}]}

/***/ }),
/* 175 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    class: {
      'card-plain': _vm.isPlain
    }
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "data-background-color": "purple"
    }
  }, [_vm._t("header", [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "category"
  }, [_vm._v(_vm._s(_vm.subTitle))])])], 2), _vm._v(" "), _c('div', {
    staticClass: "card-content table-responsive"
  }, [_c('table', {
    staticClass: "table",
    class: _vm.tableClass
  }, [_c('thead', _vm._l((_vm.columns), function(column) {
    return _c('th', [_vm._v(_vm._s(column))])
  })), _vm._v(" "), _c('tbody', _vm._l((_vm.data), function(item) {
    return _c('tr', _vm._l((_vm.columns), function(column) {
      return (_vm.hasValue(item, column)) ? _c('td', [_vm._v(_vm._s(_vm.itemValue(item, column)))]) : _vm._e()
    }))
  }))])])])
},staticRenderFns: []}

/***/ }),
/* 176 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('form', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Company",
      "disabled": true,
      "placeholder": "Material dashboard"
    },
    model: {
      value: (_vm.user.company),
      callback: function($$v) {
        _vm.user.company = $$v
      },
      expression: "user.company"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Username",
      "placeholder": "Username"
    },
    model: {
      value: (_vm.user.username),
      callback: function($$v) {
        _vm.user.username = $$v
      },
      expression: "user.username"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('fg-input', {
    attrs: {
      "type": "email",
      "label": "Email",
      "placeholder": "Email"
    },
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.user.email = $$v
      },
      expression: "user.email"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "First Name",
      "placeholder": "First Name"
    },
    model: {
      value: (_vm.user.firstName),
      callback: function($$v) {
        _vm.user.firstName = $$v
      },
      expression: "user.firstName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Last Name",
      "placeholder": "Last Name"
    },
    model: {
      value: (_vm.user.lastName),
      callback: function($$v) {
        _vm.user.lastName = $$v
      },
      expression: "user.lastName"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Address",
      "placeholder": "Address"
    },
    model: {
      value: (_vm.user.address),
      callback: function($$v) {
        _vm.user.address = $$v
      },
      expression: "user.address"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "City",
      "placeholder": "City"
    },
    model: {
      value: (_vm.user.city),
      callback: function($$v) {
        _vm.user.city = $$v
      },
      expression: "user.city"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Country",
      "placeholder": "Country"
    },
    model: {
      value: (_vm.user.country),
      callback: function($$v) {
        _vm.user.country = $$v
      },
      expression: "user.country"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('fg-input', {
    attrs: {
      "type": "number",
      "label": "Postal Code",
      "placeholder": "Postal Code"
    },
    model: {
      value: (_vm.user.postalCode),
      callback: function($$v) {
        _vm.user.postalCode = $$v
      },
      expression: "user.postalCode"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(" Lamborghini Mercy, Your chick she so thirsty, I'm in that two seat Lambo.")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.aboutMe),
      expression: "user.aboutMe"
    }],
    staticClass: "form-control border-input",
    attrs: {
      "rows": "5",
      "placeholder": "Here can be your description"
    },
    domProps: {
      "value": (_vm.user.aboutMe)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.aboutMe = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updateProfile($event)
      }
    }
  }, [_vm._v("Update Profile")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header",
    attrs: {
      "data-background-color": "purple"
    }
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Edit Profile")]), _vm._v(" "), _c('p', {
    staticClass: "category"
  }, [_vm._v("Complete your profile")])])
}]}

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notifications"
  }, [_c('transition-group', {
    attrs: {
      "name": "list"
    }
  }, _vm._l((_vm.notifications), function(notification, index) {
    return _c('notification', {
      key: notification.timestamp.getTime(),
      attrs: {
        "message": notification.message,
        "icon": notification.icon,
        "type": notification.type,
        "timestamp": notification.timestamp,
        "vertical-align": notification.verticalAlign,
        "horizontal-align": notification.horizontalAlign
      },
      on: {
        "on-close": _vm.removeNotification
      }
    })
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 178 */,
/* 179 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(21);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(46);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _globalComponents = __webpack_require__(37);

var _globalComponents2 = _interopRequireDefault(_globalComponents);

var _globalDirectives = __webpack_require__(38);

var _globalDirectives2 = _interopRequireDefault(_globalDirectives);

var _globalMixins = __webpack_require__(39);

var _globalMixins2 = _interopRequireDefault(_globalMixins);

var _NotificationPlugin = __webpack_require__(35);

var _NotificationPlugin2 = _interopRequireDefault(_NotificationPlugin);

var _SidebarPlugin = __webpack_require__(36);

var _SidebarPlugin2 = _interopRequireDefault(_SidebarPlugin);

var _App = __webpack_require__(45);

var _App2 = _interopRequireDefault(_App);

var _routes = __webpack_require__(40);

var _routes2 = _interopRequireDefault(_routes);

var _chartist = __webpack_require__(41);

var _chartist2 = _interopRequireDefault(_chartist);

__webpack_require__(43);

__webpack_require__(44);

__webpack_require__(42);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_globalComponents2.default);
_vue2.default.use(_globalDirectives2.default);
_vue2.default.use(_globalMixins2.default);
_vue2.default.use(_NotificationPlugin2.default);
_vue2.default.use(_SidebarPlugin2.default);

var router = new _vueRouter2.default({
  routes: _routes2.default,
  linkActiveClass: 'active'
});

Object.defineProperty(_vue2.default.prototype, '$Chartist', {
  get: function get() {
    return this.$root.Chartist;
  }
});

new _vue2.default({
  el: '#app',
  render: function render(h) {
    return h(_App2.default);
  },
  router: router,
  data: {
    Chartist: _chartist2.default
  }
});

/***/ })
]),[180]);


// WEBPACK FOOTER //
// static/js/app.eeb2871402aedd08ffc1.js